// src/infra/api/ResultadoAmostras.js  (ou ../../infra/api/resultado conforme seu import)
import axiosInstance from "../axios";

export const StatusResultadoAmostra = {
    PENDENTE: "PENDENTE",
    PROCESSANDO: "PROCESSANDO",
    CONCLUIDO: "CONCLUIDO",
    FALHO: "FALHO",
};

export const iniciarProcessamentoAmostra = async (amostraId) => {
    try {
        const resp = await axiosInstance.post(`/resultado-amostras/processar/${amostraId}`);
        return resp.data;
    } catch (error) {
        throw new Error(error?.response?.data?.message || "Falha ao iniciar processamento da amostra.");
    }
};

export const reprocessarResultadoAmostra = async (resultadoAmostraId) => {
    try {
        const resp = await axiosInstance.post(`/resultado-amostras/${resultadoAmostraId}/reprocessar`);
        return resp.data;
    } catch (error) {
        throw new Error(error?.response?.data?.message || "Falha ao reprocessar resultado da amostra.");
    }
};

export const buscarResultadoAmostraPorId = async (id) => {
    try {
        const resp = await axiosInstance.get(`/resultado-amostras/${id}`);
        return resp.data;
    } catch (error) {
        throw new Error(error?.response?.data?.message || "ResultadoAmostra não encontrado.");
    }
};

export async function buscarUltimoResultadoAmostra(amostraId) {
    const { data } = await axiosInstance.get(`/resultado-amostras/amostra/${amostraId}/ultimo-resultado`);
    return data;
}

// ✅ ADD: delete do resultado por amostra
export async function excluirResultadosDaAmostra(amostraId) {
    try {
        await axiosInstance.delete(`/resultado-amostras/amostra/${amostraId}/resultados`);
        return true;
    } catch (error) {
        throw new Error(error?.response?.data?.message || "Falha ao excluir resultados da amostra.");
    }
}

export default {
    StatusResultadoAmostra,
    iniciarProcessamentoAmostra,
    reprocessarResultadoAmostra,
    buscarResultadoAmostraPorId,
    buscarUltimoResultadoAmostra,
    excluirResultadosDaAmostra, // ✅ ADD
};
